export default function PersonalInfoIcon() {
  return (
    <svg
      width="22"
      height="20"
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 19H6C2 19 1 18 1 14V6C1 2 2 1 6 1H16C20 1 21 2 21 6V14C21 18 20 19 16 19Z"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 6H18"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10H18"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 14H18"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.28992C8.49964 9.28992 9.31 8.47956 9.31 7.47992C9.31 6.48029 8.49964 5.66992 7.5 5.66992C6.50037 5.66992 5.69 6.48029 5.69 7.47992C5.69 8.47956 6.50037 9.28992 7.5 9.28992Z"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.3298C10.86 12.8798 9.71 11.7398 8.26 11.6098C7.76 11.5598 7.25 11.5598 6.74 11.6098C5.29 11.7498 4.14 12.8798 4 14.3298"
        stroke="#007D32"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
